module.exports = __webpack_public_path__ + "static/img/audio.4086c4a9.svg";